import { useState } from "react";
import authService from "../../services/authService";
import { useNavigate } from "react-router-dom";

const RegisterForm = () => {
    const [email, setEmail] = useState("");
    const [dni, setDni] = useState("");
    const [phone, setPhone] = useState("");
    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            window.alert("Passwords do not match");
            return;
        }

        try {
            const userData = { email,lastName, dni, phone, name, password };
            const user = await authService.register(userData);
            if (user) {
                window.alert("Registrado correctamente");
                navigate("/login");
            }
        } catch (error) {
            window.alert(error.message);
        }
    };

    return (
        <form
            onSubmit={handleSubmit}
            className="space-y-4 max-w-sm m-auto font-sans"
            autoComplete="yes"
        >
            <div>
                <label htmlFor="name" className="block text-sm font-medium ">
                    Nombre
                </label>
                <input
                    id="name"
                    type="text"
                    value={name}
                    placeholder="Nombre"
                    onChange={(e) => setName(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 rounded-md shadow-sm bg-zinc-900"
                    required
                />
            </div>
            <div>
                <label htmlFor="lastName" className="block text-sm font-medium ">
                    Apellido
                </label>
                <input
                    id="lastName"
                    type="text"
                    value={lastName}
                    placeholder="Apellido"
                    onChange={(e) => setLastName(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 rounded-md shadow-sm bg-zinc-900"
                    required
                />
            </div>
            <div>
                <label htmlFor="email" className="block text-sm font-medium ">
                    Email
                </label>
                <input
                    id="email"
                    type="email"
                    value={email}
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 rounded-md shadow-sm bg-zinc-900"
                    required
                />
            </div>
            <div>
                <label htmlFor="dni" className="block text-sm font-medium ">
                    DNI
                </label>
                <input
                    id="dni"
                    type="number"
                    value={dni}
                    placeholder="Documento de identidad (SIN PUNTOS)"
                    minLength={7}
                    onChange={(e) => setDni(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 rounded-md shadow-sm bg-zinc-900"
                    required
                />
            </div>
            <div>
                <label htmlFor="phone" className="block text-sm font-medium ">
                    Celular
                </label>
                <input
                    id="phone"
                    type="number"
                    value={phone}
                    placeholder="Numero de celular"
                    onChange={(e) => setPhone(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 rounded-md shadow-sm bg-zinc-900"
                    required
                />
            </div>

            <div>
                <label
                    htmlFor="password"
                    className="block text-sm font-medium "
                >
                    Contraseña
                </label>
                <input
                    id="password"
                    type="password"
                    value={password}
                    placeholder="Contraseña"
                    minLength={8}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="new-password"
                    className="mt-1 block w-full px-3 py-2 rounded-md shadow-sm bg-zinc-900"
                    required
                />
            </div>

            <div>
                <label
                    htmlFor="confirmPassword"
                    className="block text-sm font-medium "
                >
                    Confirmar Contraseña
                </label>
                <input
                    id="confirmPassword"
                    type="password"
                    value={confirmPassword}
                    placeholder="Confirmar contraseña"
                    minLength={8}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    autoComplete="off"
                    className="mt-1 block w-full px-3 py-2 rounded-md shadow-sm bg-zinc-900"
                    required
                />
            </div>
            <button
                type="submit"
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-md w-full"
            >
                Register
            </button>
        </form>
    );
};

export default RegisterForm;
